// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__sYBZF","rootSuccess":"CompleteLink_rootSuccess__1r7ud","rootFailure":"CompleteLink_rootFailure__Etu1H","isDisabled":"CompleteLink_isDisabled__3bYYw"};